import { BaseFetch } from "../main-model"
export default class BoardInfoModel extends BaseFetch {
    getBoardInfoBy = (data) =>
    this.authFetch({
      url: "board-info/getBoardInfoBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getBoardInfoById = (data) =>
    this.authFetch({
      url: "board-info/getBoardInfoById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateBoardInfoById = (data) =>
    this.authFetch({
      url: "board-info/updateBoardInfoById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertBoardInfo = (data) =>
    this.authFetch({
      url: "board-info/insertBoardInfo",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteBoardInfoById = (data) =>
    this.authFetch({
      url: "board-info/deleteBoardInfoById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
